export default __webpack_public_path__ + "static/media/Armbands of Celestial Radiance.fe20e2c4.jpg";